import { UserMenuFeature } from "@features/user-menu"
import { NavigationLogo, LogoCarbonBank } from "@hm/fundamental"
import { useLoadingStore } from "@shared/stores"
import { Navigation, NavigationTabsProps } from "@shared/ui"
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"

import { useNavigationConfig } from "./useNavigationConfig"
import { useScrollRestoration } from "./useScrollRestoration"

export const Layout: React.FC = () => {
	const isNotLoading = useLoadingStore(
		state => state.featuresToLoading.length === 0,
	)

	useScrollRestoration(isNotLoading)

	const location = useLocation()
	const navigate = useNavigate()
	const { productName, navigation } = useNavigationConfig()

	const navigationTabs: NavigationTabsProps[] =
		navigation?.map(nav => ({
			...nav,
			active: location.pathname === nav.url,
			onClick: () => {
				navigate(nav.url)
			},
		})) ?? []

	return (
		<div className="bg-page_background">
			<div className="w-full max-w-[1920px] min-h-screen mx-auto flex flex-col">
				<Navigation
					className="max-sm:px-4"
					rightSideButtons={<UserMenuFeature key="user-menu" />}
					rightSideButtonsMobile={<UserMenuFeature key="user-menu" />}
					navigationTabs={navigationTabs}
					data-cy="navigation-component"
				>
					<Link to="/">
						<NavigationLogo
							image={LogoCarbonBank}
							alt={"Logo Carbon Bank"}
						>
							{productName}
						</NavigationLogo>
					</Link>
				</Navigation>
				<Outlet />
			</div>
		</div>
	)
}
